// extracted by mini-css-extract-plugin
export default {"form":"_-paper-src-___form__form___CP3B-","form-text":"_-paper-src-___form__form-text___nEAtf"};